import { GlobalAxios } from "../axios/axios-config";
import { ILabExamClassification } from "../models/lab-exam-classification";

const LAB_EXAM_CLASSIFICATION_ROUTE =
  process.env.REACT_APP_EXTERNAL + "/api/v1/LabExamClassification";

export const labExamClassificationList = (params?: any) => {
  return GlobalAxios.get<ILabExamClassification[]>(
    LAB_EXAM_CLASSIFICATION_ROUTE,
    {
      params,
    },
  );
};
